import { useTranslation } from "react-i18next";

import Tag from "@components/shared/Tag";
import { READING_CALCULATION } from "@services/declarations";
import { formatVolume } from "@utils/formatVolume";

type DeclarationTagProps = {
  value: string;
  volume?: number;
  saVolume?: number;
  whVolume?: number;
};

const DeclarationTag: React.FunctionComponent<DeclarationTagProps> = ({
  value,
  volume = 0,
  saVolume = 0,
  whVolume = 0,
}) => {
  const { t } = useTranslation();
  const stringMapping: Record<string, string> = {
    [READING_CALCULATION.CLICK_OVER]: t("declaration.click_over"),
    [READING_CALCULATION.BACKWARD]: t("declaration.backward"),
    [READING_CALCULATION.WATER_HARVESTING_START]: t(
      "declaration.water_harvesting_start",
    ),
    [READING_CALCULATION.WATER_HARVESTING]: t("declaration.water_harvesting"),
    [READING_CALCULATION.WATER_HARVESTING_END]: t(
      "declaration.water_harvesting_end",
    ),
    [READING_CALCULATION.SPECIAL_ANNOUNCEMENT]: t(
      "declaration.special_announcement",
    ),
    [READING_CALCULATION.METER_READING_ADJUSTMENT]: t(
      "declaration.meter_reading_adjustment",
    ),
    [READING_CALCULATION.METER_USAGE_ADJUSTMENT]: t(
      "declaration.meter_usage_adjustment",
    ),
    [READING_CALCULATION.DISTRIBUTION_LOSS]: t("declaration.distribution_loss"),
    [READING_CALCULATION.STOCK_AND_DOMESTIC]: t(
      "declaration.stock_and_domestic",
    ),
    [READING_CALCULATION.REPLACE_METER_CAPSULE]: t(
      "declaration.replace_meter_capsule",
    ),
  };

  return (
    <Tag status="warning">
      {stringMapping[value] ?? ""}
      {volume !== 0 ? ` ${formatVolume(volume)}` : ""}
      {saVolume !== 0
        ? `, ${stringMapping[READING_CALCULATION.SPECIAL_ANNOUNCEMENT]} ${formatVolume(saVolume)}`
        : ""}
      {whVolume !== 0
        ? `, ${stringMapping[READING_CALCULATION.WATER_HARVESTING]} ${formatVolume(whVolume)}`
        : ""}
    </Tag>
  );
};

export default DeclarationTag;
